import { render, staticRenderFns } from "./OrderDepositWaitIframe.vue?vue&type=template&id=292be2b4&"
import script from "./OrderDepositWaitIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderDepositWaitIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports